import { useEffect, useState } from 'react';
import api from '../services/api';

/**
 * Live app version from GET /api/health (same process that serves HSL).
 */
export function useAppVersion(): { version: string | null; loading: boolean } {
  const [version, setVersion] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api
      .get<{ version?: string }>('/health')
      .then((res) => {
        if (cancelled) return;
        const v = res?.data?.version;
        setVersion(typeof v === 'string' && v.trim() ? v.trim() : null);
      })
      .catch(() => {
        if (!cancelled) setVersion(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { version, loading };
}

export default useAppVersion;
